import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-checkout-accordion-section',
  templateUrl: './checkout-accordion-section.component.html',
  styleUrls: ['./checkout-accordion-section.component.css'],
})
export class CheckoutAccordionSectionComponent {
  readonly title = input('');
  readonly isOpen = input(false);
  readonly isCompleted = input(false);
  readonly canContinue = input(true);
  readonly allowToggle = input(true);
  readonly backLinkText = input<string | null>(null);
  readonly continueText = input('CONTINUAR');
  readonly secondaryActionText = input<string | null>(null);
  readonly hideContinue = input(false);
  readonly stepNumber = input<number | null>(null);
  readonly summaryText = input<string | null>(null);
  readonly isLastStep = input(false);

  readonly sectionToggle = output<void>();
  readonly goBack = output<void>();
  readonly confirm = output<void>();
  readonly secondaryConfirm = output<void>();

  onBackLinkClick(event: Event): void {
    event.preventDefault();
    this.goBack.emit();
  }
}
